import { ToggleBtn } from 'mainpage/toparea/srchinput/ToggleBtn';
import * as React from 'react';
import styled from 'styled-components';

type Props = {
  label: string;
  isOn: boolean;
  onClick: () => void;
  thin?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;
export const ToggleLblBtn = ({ label, isOn, onClick, thin = false, ...props }: Props) => {
  return (
    <Toggle {...props}>
      <span className={'label'}>{label}</span>
      <ToggleBtn onClick={onClick} isOn={isOn} thin={thin} />
    </Toggle>
  );
};

const Toggle = styled.div`
  & .label {
    margin-right: 0.6rem;
    white-space: nowrap;
  }

  display: flex;
  align-items: center;
  color: #2a2c2f;
  font-size: 1.2rem;
  vertical-align: middle;
`;
